import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorHandlerService, HandleError } from './http-error-handling.service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'my-auth-token'
  })
};
@Injectable()
export class CollateralService {
  private handleError: HandleError;

  constructor(private oauthService: OAuthService,
              private http: HttpClient,
              httpErrorHandler: HttpErrorHandlerService) {
    httpOptions.headers = httpOptions.headers.set('Authorization', this.oauthService.authorizationHeader());
    this.handleError = httpErrorHandler.createHandleError('CollateralService');
  }

  public searchByVin(vin): Observable<any[]> {
    return this.http
      .get<any[]>(`${environment.api.collateral}/motor-vehicles/search/${vin}`, httpOptions)
      .pipe(
        catchError(this.handleError('searchByVin', []))
      );
  }

  retrieveVariants(slug: string) {
    return this.http.get(`${environment.api.collateral}/motor-vehicles/variants?slug=${slug}`, httpOptions)
      .pipe(
        catchError(this.handleError('retrieveVariants', []))
      );
  }

  retrieveSpecifications(nvic, collateralClass = 'car') {
    return this.http.get(`${environment.api.collateral}/motor-vehicles/variants/${nvic}/specifications/${collateralClass}`, httpOptions)
      .pipe(
        catchError(this.handleError('retrieveSpecifications', []))
      );
  }
}

